import { useState } from "react";
import Switch from '@mui/material/Switch';

export const ImageToggle = ({ hideEquipmentImage, setHideEquipmentImage }) => {
  const toggleEquipmentImage = (e) => {
    setHideEquipmentImage(e.target.checked);
  };

  return (
    <>
      <div className="displayFlex alignItemCenter" data-testid='image-toggle'>
        <Switch
          data-testid="antSwitch"
          inputProps={{ "aria-label": "Hide Images" }}
          checked={hideEquipmentImage}
          onChange={toggleEquipmentImage}
        />
        <p style={{color:"var(--color-dimgray)"}} className="marginLeftEight">Hide images</p>
      </div>
    </>
  );
};
